import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import RandomPersonnelIdentifier from "./RandomPersonnelModel/RandomPersonnelIdentifier"

export default function RandomPersonnelRemoveObservable(persons: RandomPersonnelIdentifier[], force: boolean = false): Observable<string> {
  const params: string = JSON.stringify({
    PersonIDs: persons.map(item => ({ PersonID: item.PersonID, SSN: item.ID })),
    force: force
  })

  return ObservableFromFetch<string>("RandomTest/RemovePerson", params)
}
